import { channel } from '@f/StateServices/common/broadcastChannel'

angular.module("BroadcastChannel", [])
.provider('$broadcastChannel', function BroadcastChannelProvider() {
    this.$get = () => ({ channel })
})
